import { booleanAttribute, Component, input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { provideIcons } from '@ng-icons/core';
import { lucideArrowLeft } from '@ng-icons/lucide';
import { BrnSelectImports } from '@spartan-ng/brain/select';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { HlmIconImports } from '@spartan-ng/helm/icon';
import { HlmSelectImports } from '@spartan-ng/helm/select';

import { UserMenuComponent } from '../user-menu/user-menu.component';

@Component({
  selector: 'app-header-dashboard',
  imports: [BrnSelectImports, HlmSelectImports, UserMenuComponent, HlmButtonImports, HlmIconImports, RouterModule],
  templateUrl: './header-dashboard.component.html',
  providers: [
    provideIcons({
      lucideArrowLeft,
    }),
  ],
})
export class HeaderDashboardComponent {
  canReturn = input<boolean, boolean | string>(false, { transform: booleanAttribute });
}
